import { AfterViewInit, ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { CONSTANTS_VALUE } from '../../../config/constants.module';
import { Ui } from '../../../shared/enum/ui/ui';
import { ResizeEvent } from 'angular-resizable-element';
import { BottomPanelService } from '../../services/bottom-panel.service';
import { combineLatest } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { TakeUntilDestroy } from '../../../core/component/take-until-destroy';
import { WidgetNotifyService } from '../../../shared/service/widget-notify.service';

@Component({
    selector: 'bottom-panel',
    templateUrl: './bottom-panel.component.html',
    styleUrls: ['./bottom-panel.component.scss'],
    standalone: false
})
export class BottomPanelComponent extends TakeUntilDestroy implements OnInit, AfterViewInit {
  public active: boolean;
  public collapseStatus = Ui.CollapseStatus.collapsed;
  public presetHeight = Ui.BottomPanelPresetHeight.small;
  public BottomPanelPresetHeight = Ui.BottomPanelPresetHeight;
  public CollapseStatusEnum = Ui.CollapseStatus;
  public isFiltering = false;

  private viewReady = false;
  private windowHeight: number;
  private presetSmall: number;
  private presetBig: number;
  public currentHeight: number;

  public hideBottomPanel = true;

  constructor(
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly bottomPanelService: BottomPanelService,
    private readonly widgetNotifyService: WidgetNotifyService
  ) {
    super();
  }

  ngOnInit(): void {
    this.widgetNotifyService.onArbeitsbereichChangedSubject
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(arbeitsBereich => {
        this.hideBottomPanel = arbeitsBereich.hideListView === true;
      });

    combineLatest([this.bottomPanelService.state$])
      .pipe(takeUntil(this.unsubscribe$), debounceTime(100))
      .subscribe(([bottomPanelState]) => {
        // copy state
        this.active = bottomPanelState.active;
        this.collapseStatus = bottomPanelState.collapseStatus;
        this.presetHeight = Ui.BottomPanelPresetHeight.small;
        if (this.active && this.viewReady) {
          this.initVisibility();
        }
      });
  }

  ngAfterViewInit(): void {
    this.viewReady = true;
    this.setWindowHeight();

    if (this.active) {
      this.initVisibility();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setWindowHeight();
    if (this.active && this.viewReady) {
      this.initVisibility();
    }
  }

  initVisibility() {
    this.setPanelPresetHeight(this.presetHeight);
    this.changeDetectorRef.detectChanges();
  }

  toggleVisibility() {
    if (this.collapseStatus === Ui.CollapseStatus.open) {
      this.collapseStatus = Ui.CollapseStatus.collapsed;
    } else {
      this.collapseStatus = Ui.CollapseStatus.open;
    }
    this.bottomPanelService.setCollapseStatus(this.collapseStatus);
  }


  public validateResize(event: ResizeEvent) {
    return !(
      event.rectangle.height < CONSTANTS_VALUE.UI.bottomListMinHeight || event.rectangle.height > this.presetBig
    );
  }

  public onResizeEnd(event: ResizeEvent): void {
    this.setBottomPanelHeight(event.rectangle.height);
  }

  public setPanelPresetHeight(preset: Ui.BottomPanelPresetHeight) {
    if (preset === Ui.BottomPanelPresetHeight.small) {
      this.setBottomPanelHeight(this.presetSmall);
    } else if (preset === Ui.BottomPanelPresetHeight.big) {
      this.setBottomPanelHeight(this.presetBig);
    }
  }

  private setBottomPanelHeight(height: number) {
    this.currentHeight = height;
    this.bottomPanelService.heightBottomPanel = height;
  }

  private setWindowHeight() {
    this.windowHeight = window.innerHeight;
    this.presetSmall = CONSTANTS_VALUE.UI.bottomListSmallHeight;
    this.presetBig = this.windowHeight - CONSTANTS_VALUE.UI.mainMenuHeight;
  }
}
